import { addZero } from "./addZero";

export function parseDate(date) {
    return {
        YYYY: `${date.getFullYear()}`,
        MM: addZero(date.getMonth() + 1),
        DD: addZero(date.getDate()),
        HH: addZero(date.getHours()),
        mm: addZero(date.getMinutes()),
        ss: addZero(date.getSeconds()),
    };
}
